import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'authenticationChecklist'>,
  Pick<ReqCreateOrUpdateChallenge, 'authenticationChecklist'>
> = ({ authenticationChecklist }) => {
  if (!authenticationChecklist)
    throw Error("[AuthenticationCheckListForm] this shouldn't be happened");

  return { authenticationChecklist };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'authenticationChecklist'>,
  Pick<ChallengeFormType, 'authenticationChecklist'>
> = ({ authenticationChecklist }) => ({ authenticationChecklist });
